export const renderTemplateVariables = (text?: string): string => {
    if (!text) return '';
    return text.replace(/\{\{\s*([^{}|]+?)\s*(?:\|\s*([^{}]*?)\s*)?}}/g, (_match, _name, fallback) => fallback ?? '');
};

const NAMED_ENTITIES: Record<string, string> = {nbsp: ' ', amp: '&', lt: '<', gt: '>', quot: '"', apos: "'"};

/** The entities the rich text field writes (a blank line is `&nbsp;`), plus numeric ones. */
const decodeEntities = (text: string) => text.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (match, name: string) => {
    if (name.startsWith('#')) {
        const code = /^#x/i.test(name) ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : match;
    }

    return NAMED_ENTITIES[name.toLowerCase()] ?? match;
});

export const surveyMarkdownToPlainText = (markdown?: string): string => {
    if (!markdown) return '';

    return decodeEntities(
        renderTemplateVariables(markdown)
            .replace(/```[\s\S]*?```/g, ' ')
            .replace(/`([^`]*)`/g, '$1')
            .replace(/<[^>]+>/g, '')
            .replace(/!\[([^\]]*)]\([^)]*\)/g, '$1')
            .replace(/\[([^\]]*)]\([^)]*\)/g, '$1')
            .replace(/^\s{0,3}(#{1,6}\s+|>\s?|[-*+]\s+|\d+\.\s+)/gm, '')
            .replace(/([*_]{1,3})(\S(?:.*?\S)?)\1/g, '$2')
            .replace(/~~(.*?)~~/g, '$1')
            // After the formatting is gone: an escaped character is that character (`1\. Wie` is "1. Wie"),
            // and a backslash closing a line is a line break.
            .replace(/\\([\\`*_{}[\]()#+\-.!|<>~])/g, '$1')
            .replace(/\\\n/g, '\n')
    )
        .replace(/\s+/g, ' ')
        .trim();
};
